import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { env } from '../../environments/environment';
import { BuyResponseDto, Currency, ShopCartDto } from '../api';
import { CrisprQueryParameters } from '../api/crispr.query';
import { defs } from '../defs';

@Injectable({
	providedIn: 'root'
})
export class CrisprService {
	queryParams: BehaviorSubject<any>;
	queryParams$: Observable<any>;
	totalCount$: Subject<number>;

	constructor(private http: HttpClient) {
		this.queryParams = new BehaviorSubject({});
		this.queryParams$ = this.queryParams.asObservable();
		this.totalCount$ = new Subject<number>();
	}

	setQueryParams(queryParams) {
		this.queryParams.next(queryParams);
		localStorage.setItem(defs.crisprFilter, JSON.stringify(queryParams));
	}

	public getCrisprImprovements(
		queryParams: CrisprQueryParameters,
		reportProgress: boolean = false
	): Observable<any> {
		let params = new HttpParams();

		for (const key in queryParams) {
			if (queryParams.hasOwnProperty(key)) {
				params = params.set(key, queryParams[key]);
			}
		}
		params = params.set('so', defs.sortOrders.crispr[queryParams.sortBy]);

		return this.http.get(`${env.beURL}/shop/list`, {
			params,	observe: 'body', reportProgress
		}).pipe(
			tap(result => {
				this.totalCount$.next(result.total);
			})
		);
	}

	public getCrisprCart(): Observable<ShopCartDto> {
		return this.http.get<ShopCartDto>(`${env.beURL}/shop/cart`);
	}

	addToCart(itemId: string): Observable<any> {
		return this.http.get<any>(env.beURL + '/shop/cart/add/' + itemId);
	}

	removeFromCart(itemId: string): Observable<any> {
		return this.http.delete<any>(env.beURL + '/shop/cart/remove/' + itemId);
	}

	buyCrisprCart(currency: Currency): Promise<BuyResponseDto> {
		return this.http.get<BuyResponseDto>(env.beURL + '/shop/cart/buy/' + currency).toPromise();
	}
}